exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root[data-v-2f91bd12] {\n  width: 33%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.brick[data-v-2f91bd12] {\n  width: 4rem;\n  height: 4rem;\n}\n", ""]);

